module.exports = __webpack_public_path__ + "static/media/art_on_ice.a21c49ac.jpg";